var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompass3 = function SvgCompass3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#compass3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.999 14.667a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.813 5.51c.326-.108.489-.162.597-.124a.33.33 0 0 1 .202.202c.039.109-.015.271-.124.597L9.496 9.16c-.03.093-.046.14-.072.178a.3.3 0 0 1-.087.087c-.039.026-.085.042-.178.073l-2.975.991c-.326.109-.489.163-.597.124a.33.33 0 0 1-.202-.201c-.039-.109.016-.272.124-.597l.992-2.975c.031-.093.046-.14.073-.178a.3.3 0 0 1 .087-.087c.038-.026.085-.042.177-.073z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "compass3_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff"
  })))));
};
export default SvgCompass3;